module.exports = __webpack_public_path__ + "static/media/Cindy@2x.329adc72.png";